<template>
    <UIDetailsCard
        class="mx-4"
        :details="config.data.details"
        :title="config.data.title"
        :header="config.data.header"
        :loading="loading"
        @click="onClick"
    />
</template>

<script setup>
    import { useRouter } from 'vue-router'

    const props = defineProps({
        config: Object,
    })

    const router = useRouter()

    const moduleHelpers = useModuleHelpers()

    const loading = ref(false)
    const clicking = ref(false)
    let loadingDelay = null

    const onClick = (item) => {
        if (!item || clicking.value) {
            return
        }

        clicking.value = true
        loadingDelay = delay(() => { loading.value = true }, 1000)
        moduleHelpers.handleClick(router, item, null, false)
            .catch((e) => {
                console.log('Failed to open link', e)
            })
            .finally(() => {
                clearTimeout(loadingDelay)
                loading.value = false
                clicking.value = false
            })
    }
</script>
